module.exports = __webpack_public_path__ + "static/media/tåg-min.4588b5aa.png";